module.exports = __webpack_public_path__ + "img/tools_Executive_Compensation_Survey.6801f6bd.jpg";